import { assertEvent, assign } from 'xstate';

import { createLogic as createChatAgentLogic } from './actors/chatAgent/logic';
import { createLogic as createControlActorLogic } from './actors/control/logic';
import { machine } from './orchestrationMachine';

export const createLogic = () =>
	machine.provide({
		actors: {
			controlActorSrc: createControlActorLogic(),
			chatAgentActorSrc: createChatAgentLogic(),
		},
		guards: {
			isChatAgent: ({ context }) => context.draft?.metadata?.variant === 'chat_agent',
		},
		actions: {
			syncDraft: assign({
				draft: ({ event }) => {
					assertEvent(event, 'sync_draft');
					return event.draft;
				},
			}),
		},
	});
